<template>
      <!-- Pricing Plans start from here -->
        <app-layout>

    <div id="Pricing"></div>
        <br>
        <upgrade-progressstep step="2"></upgrade-progressstep>
  <div class="container mb-5 mt-5">
    <!-- <div class="text-center">
      <p class="pricings">Upgrade Plans</p>
    </div> -->

    <!-- Tab Section With ID attribute Start -->
    <div class="container">
      <ul class="prodNav">
        <li  @click="onChangePlan('monthly')" class="ptItem active">
          Monthly
        </li>
        <li  @click="onChangePlan('quarterly')" class="ptItem">
          Quaterly
        </li>
        <li  @click="onChangePlan('yearly')" class="ptItem">
          Yearly
        </li>
      </ul>
      <!-- Tab Section With ID attribute End -->

      <div class=" grid xl:grid-cols-4 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-2">
        <div
          class="card card-pricing popular text-center px-1 mb-4"
          v-for="(data, key) in plansDataSorted"
          style="box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px"
        >
          <span
            class="
              h6
              w-52
              mx-auto
              px-4
              py-1
              rounded-bottom
              bg-primary
              text-white
              shadow-sm
            "
            >{{data.name}}</span
          >
          <div class="bg-transparent card-header pt-4 border-0">
            <h1
              class="h1 font-weight-normal text-primary text-center mb-0"
              data-pricing-value="15"
            >
               ₹<span class="price">{{ data.rlt_cnslsubscriptionprice_morphtomany[0].rlt_cnslsubscriptionprice_cnslsubscriptionpriceslab[0].price }}</span>
            </h1>
          </div>
          
          <div class="card-body pt-0">
            <ul class="list-unstyled mb-4">
              <li>Up to 5 users</li>
              <li>Basic support on Github</li>
              <li>Monthly updates</li>
              <li>Free cancelation</li>
            </ul>
            <jet-button  @click="moveToNextPage(data.id,data.rlt_cnslsubscriptionprice_morphtomany[0].id)" class="w-full"> <button type="button" class="w-full p-2 bg-blue-500 text-white">Order Now</button></jet-button>

          </div>
        </div>

      </div>
    </div>
  </div>
  <!-- pricing end here -->
        </app-layout>
</template>



<script>
import Navigation from "@/Layouts/Navigation.vue";
import Footer from "@/Layouts/Footer.vue";
import AppLayout from "@/Layouts/AppLayout.vue";
import JetNavLink from "@/Jetstream/NavLink.vue";
import UpgradeProgressstep from "../Views/Components/UpgradeProgressbar.vue";

export default {
  props: {
  
    subscriptionPlan: {
      type: Array,
      default: [],
    },
    productId: String,
    tenantId:String,
    sideProductName:String,
   // sideSubPlanName:String,
    // sideSubPrice:String,
  //  sideAccountName:String,
  //  accountId:String,


    
  },
  components: {
    AppLayout,
    Navigation,
    JetNavLink,
   UpgradeProgressstep
  },

  data() {
    return {
      monthValue: 30,
      quaterValue: 60,
      yearlyValue: 90,
    };
  },
  methods:{
      carausel(val){
          console.log(val);
      }
  },
  mounted() {
    // faq section
    let question = document.querySelectorAll(".question");
    this.getMonthlyPrice();

    question.forEach((question) => {
      question.addEventListener("click", (event) => {
        const active = document.querySelector(".question.active");
        if (active && active !== question) {
          active.classList.toggle("active");
          active.nextElementSibling.style.maxHeight = 0;
        }
        question.classList.toggle("active");
        const answer = question.nextElementSibling;
        if (question.classList.contains("active")) {
          answer.style.maxHeight = answer.scrollHeight + "px";
        } else {
          answer.style.maxHeight = 0;
        }
      });
    });

    $(document).ready(function () {
      var pTabItem = $(".prodNav .ptItem");
      $(pTabItem).click(function () {
        // Tab nav active functionality
        $(pTabItem).removeClass("active");
        $(this).addClass("active");

        // Tab container active functionality
        var tabid = $(this).attr("id");
        $(".prodMain").removeClass("active");
        $("#" + tabid + "C").addClass("active");

        return false;
      });
      // nav js start
      $(".nav-link").on('click',function(){
          $(this).parent().parent().find('a').removeClass('act');
          $(this).addClass("act");
      });

    
    });
     $(window).scroll(function(){
            if($(this).scrollTop() > 100){
             
              // if ($(this).scrollTop() > 1429.5999755859375) {
              //    $('.Advantages').addClass('act');
              // }
                $('.nav').addClass('sticky')
                 $("#loading").css("visibility","visible");
            } else{
                $('.nav').removeClass('sticky')
                 $("#loading").css("visibility","hidden");
            }
            
        });
// nav ends
 },
  methods: {
    onChangePlan(value) {
      if (value == "quarterly") {
        this.monthValue = 300;
      } else if (value == "yearly") {
        this.monthValue = 3000;
      } else {
        this.monthValue = 30;
      }

      if (value == "quarterly") {
        this.quaterValue = 600;
      } else if (value == "yearly") {
        this.quaterValue = 6000;
      } else {
        this.quaterValue = 60;
      }

      if (value == "quarterly") {
        this.yearlyValue = 900;
      } else if (value == "yearly") {
        this.yearlyValue = 9000;
      } else {
        this.yearlyValue = 90;
      }
    },
    moveToNextPage(subplanid, subscriptionPriceId) {
          
        //var option = $(elements).children("option:selected").val();

         //console.log(subid);
         //make an array of all the selected options

         var data = {
           productId: this.productId,
           subscriptionPlanId: subplanid,
           subscriptionPriceId: subscriptionPriceId,
           tenantId: this.tenantId,
           sideProductName: this.sideProductName,
           sideSubPlanName: this.sideSubPlanName,
           sideSubPrice: this.sideSubPrice
         //sideAccountName: this.sideAccountName,
         //accountId: this.accountId,



         };

      // this.$inertia.post(route("marketplaces.billingaccounts"), data);
       this.$inertia.post(route("marketplaces.accounts"), data);
       
    },

    getMonthlyPrice(){


    }
  },

  computed: {
    plansDataSorted() {

     // console.log("PLAN_DATA_SORTED",_.orderBy(this.plansData, 'sort_position'));
      //sort the plansData by sort_postion
      return _.orderBy(this.subscriptionPlan, 'sort_position');
    },
  },
};

</script>

<style>

 html {
    scroll-behavior: smooth;
  }
@media screen and (prefers-reduced-motion: no-preference) {
  html {
    scroll-behavior: smooth;
  }
}
	
* {
	box-sizing: border-box
}
.slider{
  background-color: #05228a;
  width: 100%;
background-size: cover;
background-repeat: no-repeat;
}
/* features card css */
.service-section{
  background-color:#f3f3f3;
}
.service-section .icon-box {
	margin-bottom: 20px;
	padding: 30px;
	border-radius: 6px;
	background-color: #f8f9fa;
}
.service-section .icon-box:hover .service-title a {
	color: #41A1FD;
}
.service-section .icon-box .service-icon {
	float: left;
	color: #41A1FD;
	font-size: 40px;
}
.service-section .icon-box .service-title {
	margin-left: 70px;
	font-weight: 700;
	margin-bottom: 15px;
	font-size: 18px;
	line-height: 1.2;
}
.service-section .icon-box .service-title a {
	color: #556270;
	transition: 0.3s;
	text-decoration: none;
}
.service-section .icon-box .service-para {
	margin-left: 70px;
	line-height: 24px;
	font-size: 14px;
}
.service-section .service-main-heading {
	color: #556270;
	padding: 0;
	margin-bottom: 20px;
	line-height: 1;
	font-size: 55px;
	font-weight: 600;
}
/* features cards end */
/* benefits start */
.benefit{
  background-color: #c9ddfd;
}
.benefits {
	color: #556270;
	padding: 0;
	margin-bottom: 60px;
	line-height: 1;
	font-size: 50px;
	font-weight: 600;
}
  /* Advantages css start from here */
     
a, a:hover, a:focus, a:active {
    text-decoration: none;
    outline: none;
}
ul {
    margin: 0;
    padding: 0;
    list-style: none;
}
/* .heading {
    margin-top: 0px;
} */

.amazing_feature {
padding-top:80px;
padding-bottom:50px;
}
.single_feature{
background: #fff none repeat scroll 0 0;
box-shadow:0 2px 30px rgba(0, 0, 0, 0.1);
margin-bottom: 30px;
padding: 40px 40px;
  display: inline-block;
  vertical-align: middle;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
  -webkit-transition-property: color;
  transition-property: color;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
}
.single_feature:before {
  content: "";
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #0b0861;
  -webkit-transform: scaleY(0);
  transform: scaleY(0);
  -webkit-transform-origin: 50% 0;
  transform-origin: 50% 0;
  -webkit-transition-property: transform;
  transition-property: transform;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
}
.single_feature:hover, .single_feature:focus, .single_feature:active {
  color: white;
}
.single_feature:hover:before, .single_feature:focus:before, .single_feature:active:before {
  -webkit-transform: scaleY(1);
  transform: scaleY(1);
}
.feature_icon{}
.single_feature i {
  border: 1px solid #e8e8e9;
  border-radius: 50%;
  color: #333;
  float: left;
  font-size: 20px;
  height: 60px;
  line-height: 60px;
  margin-right: 15px;
  position: relative;
  text-align: center;
  transition: all 0.3s ease 0s;
  width: 60px;
  z-index: 3;
  margin-top: 25px;
}
.single_feature:hover i{
  background: #fff;border: 1px solid #fff;color:#0b0861;
}
.single_feature h3 {
  text-transform: capitalize;
  font-size: 20px;
  font-weight:400;
  margin-top:0px;
  overflow: hidden;
}
.single_feature:hover h3{color:#fff;}
.single_feature span {
border-bottom: 1px dashed #ccc;
display: block;
margin: 15px auto 10px;
width: 80px;
}
.single_feature p { margin-bottom: 0 ;overflow: hidden;}
  /* Advantages end here */
  .advantages {
	color: #556270;
	padding: 0;
	margin-bottom: 50px;
	line-height: 1;
	font-size: 50px;
	font-weight: 600;
}
/* pricing cards css */
.card-pricing.popular:hover {
    /* z-index: 1; */
    border: 3px solid #007bff;
}
.card-pricing .list-unstyled li {
    padding: .5rem 0;
    color: #6c757d;
}
.pricings{
  	color: #556270;
	padding: 0;
	margin-bottom: 30px;
	line-height: 1;
	font-size: 50px;
	font-weight: 600;
}
/* pricing card end css */
/* faq css start */
.grey{
   background-color:  blue ;
   margin-left: 45%;
   margin-top: 30px;
   color: #fff;
   padding:6px 10px ;
   border-radius: 4px;
   border: 1px solid blue;
}
.grey:hover{
  
   color: #fff;
}
.faq{
  	color: #556270;
	padding: 0;
	margin-bottom: 30px;
	line-height: 1;
	font-size: 50px;
	font-weight: 600;
}
.story{
  	color: #556270;
	padding: 0;
	margin-bottom: 10px;
	line-height: 1;
	font-size: 50px;
	font-weight: 600;
}
 /* .wrapper {
  width: 60%;
} */
.cont {
  background-color: white;
  color: black;
  border-radius: 10px;
  box-shadow: 0 0px 5px 0 rgb(0,0,0,0.25);
  margin: 20px 0;
}
.question {
  font-size: 1.2rem;
  font-weight: 600;
  padding: 20px 80px 20px 20px;
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.question::after {
  content: "\276F";
  font-size: 1.2rem;
  position: absolute;
  right: 20px;
  transition: 0.2s;
}
.question.active::after {
  transform: rotate(90deg);
}
.answercont {
  max-height: 0;
  overflow: hidden;
  transition: 0.3s;
}
.answer {
  padding: 0 20px 20px;
  line-height: 1.5rem;
}
.question.active + .answercont {
}
@media screen and (max-width: 790px){
  html {
    font-size: 14px;
  }
  .wrapper {
  width: 80%;
}
}
 
/* case study start from here */
 .case{
   background-color:#f8f9fa;
 }
 .center-heading {
  text-align: center;
}
.center-heading .section-title {
  font-weight: 400;
  font-size: 28px;
  color: #3B566E;
  letter-spacing: 1.1px;
  line-height: 38px;
  margin-bottom: 20px;
}
.center-heading.colored .section-title {
  color: #ffffff;
}
.center-text {
  text-align: center;
  font-weight: 400;
  font-size: 16px;
  color: #6F8BA4;
  line-height: 28px;
  letter-spacing: 1px;
  margin-bottom: 50px;
}
.center-text.colored {
  color: #C7E5FF;
}
.center-text p {
  margin-bottom: 30px;
}
.services-small-item {
  display: block;
  background: #fff;
  box-shadow: 0 2px 48px 0 rgba(0, 0, 0, 0.06);
  border-radius: 5px;
  padding: 40px 28px;
  text-align: center;
  -webkit-transition: all 0.3s ease 0s;
  -moz-transition: all 0.3s ease 0s;
  -o-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
  position: relative;
  /* z-index: 2; */
  margin-bottom: 30px;
}
.services-small-item:before {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  border-radius: 5px;
  background-image: linear-gradient(135deg, #80d0c7 0%, #13547a 100%);
  -webkit-transition: all 0.3s ease 0s;
  -moz-transition: all 0.3s ease 0s;
  -o-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
  opacity: 0;
}
.services-small-item.active:before, .services-small-item:hover:before {
  opacity: 1;
}
.services-small-item.active .icon:before, .services-small-item:hover .icon:before {
  opacity: .26;
}
.services-small-item.active .icon i, .services-small-item:hover .icon i {
  background: -webkit-linear-gradient(#fff, #fff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.services-small-item.active .services-title, .services-small-item:hover .services-title {
  color: #ffffff;
}
.services-small-item.active p, .services-small-item:hover p {
  color: #ffffff;
}
.services-small-item.active .button i, .services-small-item:hover .button i {
  background-image: linear-gradient(135deg, #fff 0%, #fff 100%) !important;
  color: #2b708b !important;
}
.services-small-item:hover {
  margin-top: -15px;
}
.services-small-item .icon {
  width: 139px;
  height: 113px;
  margin: auto;
  position: relative;
  margin-bottom: 20px;
  -webkit-transition: all 0.3s ease 0s;
  -moz-transition: all 0.3s ease 0s;
  -o-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
}
.services-small-item .icon i {
  display: block;
  height: 67px;
  line-height: 67px;
  position: absolute;
  width: 100%;
  top: 22px;
  /* z-index: 2; */
  font-size: 28px;
  background-image: linear-gradient(135deg, #80d0c7 0%, #13547a 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  -webkit-transition: all 0.3s ease 0s;
  -moz-transition: all 0.3s ease 0s;
  -o-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
}
.services-small-item .services-title {
  font-weight: 400;
  font-size: 16px;
  color: #3B566E;
  letter-spacing: 0.7px;
  margin-bottom: 15px;
  position: relative;
  /* z-index: 2; */
  -webkit-transition: all 0.3s ease 0s;
  -moz-transition: all 0.3s ease 0s;
  -o-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
}
.services-small-item p {
  font-weight: 400;
  font-size: 14px;
  color: #6F8BA4;
  letter-spacing: 0.88px;
  line-height: 26px;
  position: relative;
  /* z-index: 2; */
  -webkit-transition: all 0.3s ease 0s;
  -moz-transition: all 0.3s ease 0s;
  -o-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
  margin-bottom: 30px;
}
.services-small-item .button {
  position: relative;
  /* z-index: 2; */
}
.services-small-item .button i {
  width: 42px;
  height: 42px;
  background-image: linear-gradient(135deg, #80d0c7 0%, #13547a 100%);
  line-height: 42px;
  text-align: center;
  -webkit-border-radius: 100px;
  -moz-border-radius: 100px;
  border-radius: 100px;
  color: #fff;
  padding-left: 3px;
}
.services-small-item:hover + .item-bg {
  bottom: 30px;
}
.btn:hover{
  color:#fff;
}
.primary{
   background-color:  #13547a ;
   margin-left: 45%;
   margin-top: 30px;
   color: #fff;
}
/* case study end */
    
    /* testimonial css start from here */   
.testimonial {
  margin-top: 50px;
    min-height: 425px;
    position: relative;
    background: #F3F3F3;
    /* background-image: url("/imgs/blue-back.jpg"); */
    padding-top: 30px;
    padding-bottom: 30px;
    /* background-position: center;
        background-size: cover;  */
}
/* .top_border{
 box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgb(209, 213, 219) 0px 0px 0px 1px inset;
} */
#testimonial4 .carousel-inner:hover{
   cursor: grab;
 cursor: grab;
}
#testimonial4 .carousel-inner:active{
  cursor: grabbing;
  cursor: grabbing;
}
#testimonial4 .carousel-inner .item{
  overflow: hidden;
}
.testimonial4_indicators .carousel-indicators::-webkit-scrollbar{
  height: 3px;
}
.testimonial4_indicators .carousel-indicators::-webkit-scrollbar-thumb{
  background: #eeeeee;
  -webkit-border-radius: 0;
  border-radius: 0;
}
.testimonial4_control_button .carousel-control{
  top: 175px;
  opacity: 1;
  width: 40px;
  bottom: auto;
  height: 40px;
  font-size: 10px;
  cursor: pointer;
  font-weight: 700;
  overflow: hidden;
  line-height: 38px;
  text-shadow: none;
  text-align: center;
  position: absolute;
  background: transparent;
  border: 2px solid black;
  text-transform: uppercase;
  -webkit-border-radius: 100%;
  border-radius: 100%;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-transition: all 0.6s cubic-bezier(0.3,1,0,1);
  transition: all 0.6s cubic-bezier(0.3,1,0,1);
}
.testimonial4_control_button .carousel-control.left{
  left: 3%;
  top: 50%;
  right: auto;
}
.testimonial4_control_button .carousel-control.right{
  right: 3%;
  top: 50%;
  left: auto;
}
.testimonial4_control_button .carousel-control.left:hover,
.testimonial4_control_button .carousel-control.right:hover{
  color: #000;
  background:black;
  border: 2px solid black;
}
.testimonial4_header{
  top: 0;
  left: 0;
  bottom: 0;
  width: 550px;
  display: block;
  margin: 30px auto;
  text-align: center;
  position: relative;
}
.testimonial4_slider{
  width: 90%;
  margin: auto;
  /* padding: 20px; */
  position: relative;
 
}
.slider_img {
     width: 220px;
    display: block;
    /* color: black; */
    font-size: 18px;
    line-height: 46px;
    padding: 20px ;
    position: relative; 
}

.testimonial .carousel {
	padding-bottom:50px;
}
.testimonial .carousel-control-next-icon, .testimonial .carousel-control-prev-icon {
    width: 25px;
    height: 25px;   
}
.carousel-control-prev{
 justify-content:flex-start;
}
.carousel-control-next{
 justify-content:end;
}
/* ------testimonial subscription button start from here-------*/

.input-holder{
  font-family: 16px;
  display: flex;
  /* align-items: left: ;; */
  align-items:flex-start;
  /* justify-content: center; */
  gap: .4em;
}
.input-holder input{
  padding-right: 8rem;
  font-size: 1rem;
  font-weight: 400;
  border-radius: .3rem;
  border: 1px solid #e0e0e0;
  box-shadow: inset 1px 1px 1px #e0e0e080;
  color: #4c575c;
  transition: all .25s ease 0s;
}
.input-holder input:focus{
  border-color: #409eff;
  outline: none;
  box-shadow: inset 1px 1px 1px #e0e0e080, 0 0 0 3px #409eff80;
}
.input-holder button{
  padding: 0.5rem  1rem;
  font-size: 1rem;
  font-weight: 600;
  border-radius: .3rem;
  border: 1px solid #3b82f6;
  background: #3b82f6;
  color: #E5E5E5;
  transition: all .25s ease 0s;
  cursor: pointer;
}
.input-holder button:focus{
  border-color: #409eff;
  outline: none;
  box-shadow: 0 0 0 3px #409eff80;
}
.label {
  pointer-events: none;
  position: absolute;
  top: 2.7rem;
  right: 1.5rem;
  color: #fff;
  font-weight: 700;
  font-size: 1.4rem;
  transition: all 0.2s;
  transform-origin: left;
}
.welcome-container img {
  width: 100%;
} 
  .label {
    font-size: 1rem;
  }
    /* testinomial end here */
    /* footer css start from here */
   
    /* footer css end */
    .prodNav {
  margin: 50px 0 20px;
  background: #f5f5f5;
  width: 400px;
  padding: 6px;
  border-radius: 32px;
margin-left: 340px;
}
 /* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .prodNav {
 margin-left: 20px;
  }
}
/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .prodNav {
 margin-left: 40px;
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .prodNav {
 margin-left: 140px;
  }
}
/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .prodNav {
 margin-left: 250px;
  }
}
/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .prodNav {
 margin-left: 340px;
  }
} 
.prodNav .ptItem {
  padding: 9px 35px;
  line-height: 20px;
  border-radius: 20px;
  border: 1px solid transparent;
  font-weight: 500;
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  transition: all 0.3s ease-in-out;
}
.prodNav .ptItem.active
 {
  background: #007BFF;
  border-color: #007BFF;
  color: #ffffff;
}
.prodNav:hover{
background: #f5f5f5;
border-color: #f5f5f5;
}
/* .prodMain {
  display: none;
  padding: 20px;
  color: #ffffff;
}
.prodMain.active {
  display: block;
} */
/* navbar css start from here */
.nav{
    z-index: 1;
    padding: 5px;
}

.sticky{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%
}
.img_size{
    height: auto;
    width: 56px;
}
.navbar-light .navbar-nav .nav-link{
  color: white;
}
.navbar-light .navbar-nav .act{
  color: yellow;
  /* font-weight: bold; */
}
.navbar-light .navbar-nav .act:hover{
  color: yellow;
  /* font-weight: bold; */
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .navbar-light .navbar-toggle {
  color: rgba(0,0,0,.5);
  border-color: rgba(0,0,0,.1);
  /* width: %; */
  margin-left: 200px;
}
}
/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
   .navbar-light .navbar-toggle {
  color: rgba(0,0,0,.5);
  border-color: rgba(0,0,0,.1);
  /* width: %; */
  margin-left: 400px;
}
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .navbar-light .navbar-toggle {
  color: rgba(0,0,0,.5);
  border-color: rgba(0,0,0,.1);
  margin-left: 500px;
}
}
/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .navbar-light .navbar-toggle{
    display: none;
  }
}
/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
   .navbar-light .navbar-toggle{
    display: none;
  }
}
/* navbar end here */
</style>